<p class="label">{{label}}</p>
<mat-form-field appearance="outline">
  @if (type === 'date') {
    <ng-container>
      <input matInput 
        [placeholder]="placeholder"
        [formControl]="control" 
        [matDatepicker]="datePicker"
        (input)="updateValue($event)"
        (blur)="handleBlur()"
        (dateChange)="onDateChange($event.value)"
        (click)="datePicker.open()"
      >
      <mat-icon (click)="datePicker.open()">calendar_month</mat-icon>
      <mat-datepicker #datePicker></mat-datepicker>
    </ng-container>
  } @else if (type === 'time') {
    <ng-container>
      <input matInput 
        [placeholder]="placeholder"
        [formControl]="control" 
        [matTimepicker]="timePicker"
        (input)="updateValue($event)"
        (valueChange)="onDateChange($event)"
        (blur)="handleBlur()"
        (click)="timePicker.open()"
        >
      <mat-timepicker-toggle class="time-toggle" matIconSuffix [for]="timePicker"/>
      <!-- <mat-icon (click)="timePicker.open()">calendar_month</mat-icon> -->
      <mat-timepicker #timePicker />
    </ng-container>
  } @else if (type === 'autocomplete') {
    <input matInput
      #autoCompleteElement
      [placeholder]="placeholder"
      [formControl]="control" 
      [type]="type"
      [matAutocomplete]="auto"
      (input)="updateValue($event)"
      (blur)="handleBlur()"
      (focus)="handleFocus()"
      [readonly]="isReadonly"
      inputmode="none"
    >
    <mat-autocomplete 
      autoActiveFirstOption 
      #auto="matAutocomplete" 
      [displayWith]="autocompleteDisplayFunction()"
      (optionSelected)="onOptionSelected($event)">
      @for (option of autocompleteList(); track option) {
        <mat-option [value]="option">{{option[autocompleteOptionLabel()]}}</mat-option>
      }
    </mat-autocomplete>
  } @else {
    <input matInput 
      [placeholder]="placeholder"
      [formControl]="control" 
      [type]="type"
      (input)="updateValue($event)"
      (blur)="handleBlur()"
    >
  }
</mat-form-field>

@if (invalid && errors) {
    @if (errors['required']) {
      <div class="error">
        {{ 'errors.field_required' | translate }}
      </div>
    } @else if (errors['minlength']) {
      <div class="error">
        {{ 'errors.min_length' | translate:{min: errors['minlength'].requiredLength, current: errors['minlength'].actualLength} }}
      </div>
    } @else if (errors['passwordMismatch']) {
      <div class="error">
        {{ 'errors.password_mismatch' | translate }}
      </div>
    } @else {
      <div class="error">
        {{ 'errors.invalid_field' | translate }}
      </div>
    }
}
